<template>
  <div class="loadingView" v-if="loadingForm">
    <LoadingList v-model="loadingForm" text="Carregando dados." />
  </div>
  <div v-else>
    <RequiredFieldsMessage :cmeTerms="false" />
    <div>
      <b-card-header header-tag="header" role="tab">
        <h5
          style="padding-top: 0"
          v-b-toggle="'accordion-1-' + value.enrollment_id"
        >
          Saúde
        </h5>
      </b-card-header>
      <b-collapse
        :id="'accordion-1-' + value.enrollment_id"
        visible
        :accordion="'my-accordion-' + value.enrollment_id"
        :role="'tabpanel-' + value.enrollment_id"
      >
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Vacinas em dia até data presente</label>
              <b-form-radio-group
                v-model="value.vaccines_up_to_date"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'vaccines_up_to_date' + value.enrollment_id"
                :id="'vaccines_up_to_date' + value.enrollment_id"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Restrição alimentar</label>
              <b-form-radio-group
                v-model="value.food_restriction"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'food_restriction' + value.enrollment_id"
                :id="'food_restriction' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.food_restriction"
              v-model="value.food_restriction_description"
              class="required"
              type="text"
              :name="'food-restriction' + value.enrollment_id"
              :id="'food-restriction' + value.enrollment_id"
              label="Especifique:"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Problema crônico de saúde</label>
              <b-form-radio-group
                v-model="value.health_problem"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'health_problem' + value.enrollment_id"
                :id="'health_problem' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.health_problem"
              v-model="value.health_problem_description"
              class="required"
              type="text"
              :name="'chronic-health-problem' + value.enrollment_id"
              :id="'chronic-health-problem' + value.enrollment_id"
              label="Especifique:"
              placeholder=""
            >
            </StandardInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Limitações</label>
              <b-form-radio-group
                v-model="value.limitation"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'limitation' + value.enrollment_id"
                :id="'limitation' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.limitation"
              v-model="value.limitation_description"
              class="required"
              type="text"
              :name="'limitations' + value.enrollment_id"
              :id="'limitations' + value.enrollment_id"
              label="Especifique:"
              placeholder=""
            >
            </StandardInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Acompanhamento especializado</label>
              <b-form-radio-group
                v-model="value.special_accompaniment"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'special_accompaniment' + value.enrollment_id"
                :id="'special_accompaniment' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.special_accompaniment"
              v-model="value.special_accompaniment_description"
              class="required"
              type="text"
              :name="'specialized-monitoring' + value.enrollment_id"
              :id="'specialized-monitoring' + value.enrollment_id"
              label="Especifique:"
              placeholder=""
            >
            </StandardInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Cuidado especial por motivo de saúde</label>
              <b-form-radio-group
                v-model="value.special_care"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'special_care' + value.enrollment_id"
                :id="'special_care' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.special_care"
              v-model="value.special_care_description"
              class="required"
              type="text"
              :name="'special-care-health-reasons' + value.enrollment_id"
              :id="'special-care-health-reasons' + value.enrollment_id"
              label="Especifique:"
              placeholder=""
            >
            </StandardInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              class="group-radio required"
              v-slot="{ ariaDescribedby }"
            >
              <label for="">Possui convênio médico</label>
              <b-form-radio-group
                v-model="value.healthcare"
                :options="options.boolean"
                :aria-describedby="ariaDescribedby"
                :name="'healthcare' + value.enrollment_id"
                :id="'healthcare' + value.enrollment_id"
                @input="setDescriptionfieldNull()"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <StandardInput
              v-if="value.healthcare"
              v-model="value.healthcare_description"
              class="required"
              type="text"
              :name="'medical-insurance' + value.enrollment_id"
              :id="'medical-insurance' + value.enrollment_id"
              label="Especifique:"
              placeholder=""
            >
            </StandardInput>
          </b-col>
        </b-row>
      </b-collapse>
      <!-- Item -->
    </div>
    <b-card-header header-tag="header" role="tab">
      <h5 block v-b-toggle="'accordion-2-' + value.enrollment_id">
        Em caso de emergência, não sendo localizados os responsáveis, entrar em
        contato com:
      </h5>
    </b-card-header>
    <b-collapse
      :id="'accordion-2-' + value.enrollment_id"
      :accordion="'my-accordion-2-' + value.enrollment_id"
      :role="'tabpanel-' + value.enrollment_id"
    >
      <b-row>
        <b-col md="6">
          <StandardInput
            v-model="value.contact1"
            class="required"
            type="text"
            :name="'first-contact' + value.enrollment_id"
            :id="'first-contact' + value.enrollment_id"
            label="Primeiro contato"
          >
          </StandardInput>
        </b-col>
        <b-col md="4">
          <StandardInput
            v-model="value.contact1_phone"
            class="required"
            type="text"
            :name="'first-phone' + value.enrollment_id"
            :id="'first-phone' + value.enrollment_id"
            label="Telefone"
            v-mask="'(##) #####-####'"
          >
          </StandardInput>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <StandardInput
            v-model="value.contact2"
            class="required"
            type="text"
            :name="'second-contact' + value.enrollment_id"
            :id="'second-contact' + value.enrollment_id"
            label="Segundo contato"
          >
          </StandardInput>
        </b-col>
        <b-col md="4">
          <StandardInput
            v-model="value.contact2_phone"
            class="required"
            type="text"
            :name="'second-phone' + value.enrollment_id"
            :id="'second-phone' + value.enrollment_id"
            label="Telefone"
            v-mask="'(##) #####-####'"
          >
          </StandardInput>
        </b-col>
      </b-row>
    </b-collapse>
    <!-- Item -->

    <b-card-header header-tag="header" role="tab">
      <h5 block v-b-toggle="'accordion-3-' + value.enrollment_id">
        Retorno para residência
      </h5>
    </b-card-header>
    <b-collapse
      :id="'accordion-3-' + value.enrollment_id"
      :accordion="'my-accordion-3-' + value.enrollment_id"
      :role="'tabpanel-' + value.enrollment_id"
    >
      <b-row style="justify-content: space-between">
        <b-col md="12" v-if="returnToHomeNote">
          <p class="return-note">
            {{ returnToHomeNote }}
          </p>
        </b-col>
        <b-col md="4">
          <b-form-group :class="`required ${showTooltip ? 'tool' : ''} `">
            <label for="">Forma de retorno </label>
            <div style="display: flex; align-items: center; gap: 8px">
              <multiselect
                v-model="value.return_to_home"
                :options="returnToHomeOptions"
                :multiple="false"
                :disabled="isReturnToHomeLocked"
                placeholder="Selecione"
                class="required"
                selectLabel=""
                @input="setContact($event)"
              />
              <span
                v-b-tooltip.hover
                title="A saída de alunos até o final do 1º ciclo deve ser feita na companhia de um responsável."
                style="display: inline-flex; cursor: pointer"
                v-if="showTooltip"
              >
                <font-awesome-icon
                  icon="fa-regular fa-circle-question"
                  class="lg"
                  style="font-size: 1.5em; color: #b23066"
                />
              </span>
            </div>
          </b-form-group>
        </b-col>

        <b-col
          md="4"
          style="padding-top: 9px"
          v-if="
            value.return_to_home === 'Acompanhado' &&
            (!addReturnContact ||
              (value.EnrollmentComplementContacts &&
                value.EnrollmentComplementContacts.length === 0))
          "
        >
          <b-button
            type="button"
            class="btn blue"
            @click="handleAuthorizedPerson"
            style="font-size: 16px; height: 70px"
          >
            Cadastrar pessoa autorizada a buscar o aluno além dos contratantes
          </b-button>
        </b-col>
      </b-row>

      <template
        v-if="
          value.return_to_home === 'Acompanhado' &&
          value.EnrollmentComplementContacts.length > 0
        "
      >
        <b-row
          v-for="(contact, index) in value.EnrollmentComplementContacts"
          :key="index"
          class="profile-contact"
        >
          <b-col>
            <h5 class="mb-4">Contato {{ index + 1 }}</h5>
          </b-col>
          <b-button
            v-if="
              !isPousoAlegre ||
              value.EnrollmentComplementContacts.length > 1
            "
            @click="removeContact(index)"
            type="button"
            class="btn blue mb-5 add"
          >
            Remover Contato
          </b-button>

          <div class="w-100"></div>
          <b-col md="3">
            <b-form-group>
              <ProfilePhoto
                class="form-group required photo-field"
                :modalId="`modal-complementary-${index + 1}`"
                :photo="contact.photo"
                :callback="(photo) => setNewPhoto(contact, photo)"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-row>
              <b-col>
                <StandardInput
                  v-model="contact.name"
                  class="required"
                  type="text"
                  :name="'full-name' + value.enrollment_id"
                  :id="'full-name' + value.enrollment_id"
                  label="Nome completo"
                />
              </b-col>
              <b-col>
                <StandardInput
                  v-model="contact.relationship"
                  class="required"
                  type="text"
                  :name="'kinship' + value.enrollment_id"
                  :id="'kinship' + value.enrollment_id"
                  label="Relação com aluno"
                />
              </b-col>
              <b-col>
                <StandardInput
                  v-model="contact.number1"
                  class="required"
                  type="text"
                  :name="'phone-1' + value.enrollment_id"
                  :id="'phone-1' + value.enrollment_id"
                  label="Telefone 1"
                  v-mask="'(##) #####-####'"
                />
              </b-col>
              <div class="w-100"></div>
              <b-col md="4">
                <StandardInput
                  v-model="contact.number2"
                  type="text"
                  :name="'phone-2' + value.enrollment_id"
                  :id="'phone-2' + value.enrollment_id"
                  label="Telefone 2"
                  v-mask="'(##) #####-####'"
                  :required="false"
                />
              </b-col>
            </b-row>
          </b-col>
          <div class="w-100"></div>
          <b-col
            class="wrap-add"
            md="12"
            v-if="
              index === value.EnrollmentComplementContacts.length - 1 &&
              value.EnrollmentComplementContacts.length <= 3
            "
          >
            <b-button
              @click="addNewContact"
              type="button"
              class="btn large blue mb-5 add"
            >
              <b-icon-plus-lg />Adicionar contatos
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-collapse>
  </div>
</template>

<script>
import StandardInput from "@/components/inputs/StandardInput.vue";
import ProfilePhoto from "@/components/ProfilePhoto.vue";
import httpRda from "../../../http-rda";
import LoadingList from "@/components/LoadingList.vue";
import RequiredFieldsMessage from "@/components/RequiredFieldsMessage.vue";
import {
  CYCLES_ALLOWING_ALONE,
  CYCLES_REQUIRING_COMPANION,
  isPousoAlegreUnit,
} from "@/utils/returnToHomeRules";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
library.add(faCircleQuestion);

export default {
  name: "Complementary",
  components: {
    FontAwesomeIcon,
    StandardInput,
    LoadingList,
    ProfilePhoto,
    RequiredFieldsMessage,
  },

  props: ["value"],

  data() {
    return {
      cycleId: null,
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      addReturnContact: false,
      enrollmentId: this.$route.params.id
        ? this.$route.params.id
        : this.value.enrollment_id,
      loadingForm: true,
      options: {
        boolean: [
          { text: "Sim", value: true },
          { text: "Não", value: false },
        ],
        return_to_home: ["Sozinho", "Acompanhado"],
      },
    };
  },

  computed: {
    isPousoAlegre() {
      return isPousoAlegreUnit(this.rdaUnit);
    },

    returnToHomeOptions() {
      if (CYCLES_REQUIRING_COMPANION.includes(this.cycleId)) {
        return ["Acompanhado"];
      }
      if (CYCLES_ALLOWING_ALONE.includes(this.cycleId)) {
        return ["Sozinho"];
      }
      return ["Sozinho", "Acompanhado"];
    },

    returnToHomeNote() {
      if (CYCLES_ALLOWING_ALONE.includes(this.cycleId)) {
        return "* A saída de alunos do turno da manhã, ao final das aulas, é irrestrita, cabendo aos responsáveis definir critérios diretamente com o aluno.";
      }
      return null;
    },

    showTooltip() {
      return (
        this.returnToHomeOptions.length === 1 &&
        this.returnToHomeOptions[0] === "Acompanhado"
      );
    },

    isReturnToHomeLocked() {
      return this.returnToHomeOptions.length === 1;
    },
  },

  methods: {
    async loadComplements() {
      if (this.value !== undefined && this.value.id !== undefined) {
        if (
          this.value.EnrollmentComplementContacts === undefined ||
          this.value.EnrollmentComplementContacts.length === 0
        ) {
          this.value.EnrollmentComplementContacts = [];
        } else {
          for (const element of this.value.EnrollmentComplementContacts) {
            element.shouldUpdatePhoto = !element.photo;
          }

          this.addReturnContact = true;
        }
      } else {
        this.addReturnContact = true;
      }

      await this.$nextTick();

      if (this.cycleId !== null) {
        if (
          this.returnToHomeOptions.length === 1 &&
          !this.value.return_to_home
        ) {
          this.value.return_to_home = this.returnToHomeOptions[0];
          this.setContact(this.value.return_to_home);
        } else if (
          this.value.return_to_home &&
          !this.returnToHomeOptions.includes(this.value.return_to_home)
        ) {
          this.value.return_to_home = this.returnToHomeOptions[0];
        }
      }

      this.loadingForm = false;
    },

    setDescriptionfieldNull() {
      for (const key in this.value) {
        if (
          this.value[key] === false &&
          this.value[`${key}_description`] !== undefined
        ) {
          this.value[`${key}_description`] = "";
        }
      }
    },

    async removeContact(index) {
      const response = confirm("Deseja realmente deletar esse contato?");

      if (response) {
        const [contact] = this.value.EnrollmentComplementContacts.splice(
          index,
          1
        );

        if (contact.id) {
          await httpRda.delete(
            `/enrollments/${
              this.enrollmentId ? this.enrollmentId : this.value.enrollment_id
            }/contacts/${contact.id}`
          );
        }
      }
    },

    async getEnrollmentCycleId() {
      if (this.enrollmentId) {
        try {
          const response = await httpRda.get(
            `/enrollments/${this.enrollmentId}/cycle`
          );
          this.cycleId = response.data.cycleId;
        } catch (_) {
          return;
        }
      }
    },

    async setContact(value) {
      this.addReturnContact = false;
      if (value === "Acompanhado") {
        if (this.value.EnrollmentComplementContacts.length === 0) {
          this.addReturnContact = false;
        }
      } else {
        if (this.value.EnrollmentComplementContacts.length > 0) {
          const result = confirm(
            "Essa ação irá deletar todos os contatos complementares previamente existentes!\nDeseja continuar?"
          );
          if (result) {
            for (const contact of this.value.EnrollmentComplementContacts) {
              if (contact.id) {
                await httpRda.delete(
                  `/enrollments/${
                    this.enrollmentId
                      ? this.enrollmentId
                      : this.value.enrollment_id
                  }/contacts/${contact.id}`
                );
              }
            }
            this.value.EnrollmentComplementContacts = [];
          } else {
            this.value.return_to_home = "Acompanhado";
          }
        }
      }
    },

    addNewContact() {
      this.value.EnrollmentComplementContacts.push({
        photo: null,
        name: "",
        relationship: "",
        number1: "",
        number2: "",
        shouldUpdatePhoto: true,
      });
    },

    setNewPhoto(contact, photo) {
      contact.photo = photo;
      contact.shouldUpdatePhoto = false;
    },

    handleAuthorizedPerson() {
      this.addReturnContact = true;
      if (this.value.EnrollmentComplementContacts.length === 0) {
        this.addNewContact();
      }
    },
  },

  async mounted() {
    await this.getEnrollmentCycleId();
    await this.loadComplements();
  },
};
</script>

<style lang="scss" scoped>
.wrap-add {
  padding-top: 40px;

  .add {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      font-size: 16px !important;
      position: relative;
      top: -1px;
    }
  }
}

.profile-contact {
  border-bottom: 0;
  padding-bottom: 0;
}

.return-note {
  color: #666;
  font-style: italic;
  margin-top: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-left: 3px solid #b23066;
}

.form-group.required.tool:after {
  right: 30px;
}
</style>
